<template>
  <gj-modal
      size="400Auto"
      :visible.sync="modalVisible"
      :confirmLoading="confirmLoading"
      no-padding
      @cancel="cancel"
      @confirm="confirm"
      class="place-on-file-modal"
  >
    <template #header>归档</template>
    <template #content>
      <el-form ref="form" :model="param" style="padding: 12px 48px 16px 0;">

        <el-form class="flex align-center">
          <span style="width: 100px;text-align: right;">结果</span>
          <gj-select
              v-model="param.lastResult"
              :options="trackingResultsOption"
              placeholder="请选择结果"
              class="detail-input"
          >
          </gj-select>
        </el-form>

        <div class="flex align-center" style="padding-top: 16px;">
          <span style="width: 100px;text-align: right;">最终星级</span>
          <gj-rate class="detail-input" v-model="param.lastStar"></gj-rate>
        </div>

        <div class="flex align-center" style="padding-top: 16px;" v-if="mailType === 'NR'">
          <gj-required style="width: 100px;text-align: right;">匹配结果反馈</gj-required>
          <el-form-item
              prop="matchResult"
              :rules="[
                  { required: true, message: '请选择匹配类型', trigger: ['change'] }
                ]"
              style="margin: 0 0 0 12px;"
          >
            <gj-select
                v-model="param.matchResult"
                :options="[
                  {id:2,text:'无法判断'},
                  {id:1,text:'正确'},
                  {id:0,text:'错误'}
              ]"
                placeholder="请选择"

                width="240px"
            >
            </gj-select>
          </el-form-item>

        </div>
      </el-form>

    </template>
  </gj-modal>
</template>

<script>
import {formMixin, formRuleMixin, formValidatorMixin, modalMixIn} from "@/minxins";
import {trackingResultsOption} from "@/utils/options";
import {archiveOrder, archive} from "@/api/crm";
import {isMeaningless} from "@/utils/common";

export default {
  name: "place-on-file-modal",
  mixins: [
    modalMixIn, formValidatorMixin
  ],
  props: {
    id: null,
    mailType: null,
    matchResult:null
  },
  data() {
    return {
      confirmLoading: false,
      param: {
        lastStar: null,
        lastResult: null,
        matchResult: this.matchResult,
        id: this.id
      },
      trackingResultsOption,

    }
  },
  methods: {
    confirm() {
      if (this.mailType === 'NR') {
        if (!this.formValidate()) {
          return
        }
        this.confirmLoading = true;
        archiveOrder(this.param).then(res => {
          this.$emit('placeAfter')
          this.modalVisible = false;
        }).complete(()=>{
          this.confirmLoading = false;
        })
      }else if(this.mailType === 'NF') {
        archive(this.param.id,this.param.lastResult,this.param.lastStar).then(res => {
          this.$emit('placeAfter')
          this.modalVisible = false;
        }).complete(()=>{
          this.confirmLoading = false;
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.detail-input {
  flex: 1;
  margin-left: 12px;
}
.place-on-file-modal {
  /deep/ .gj-modal--400Auto {
    .el-dialog {
        width: 400px !important;
        height: auto !important;
    }
  }
}

</style>